import { render, staticRenderFns } from "./IdentityProviders.vue?vue&type=template&id=397f6826&scoped=true&"
import script from "./IdentityProviders.vue?vue&type=script&lang=ts&"
export * from "./IdentityProviders.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityProviders.vue?vue&type=style&index=0&id=397f6826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f6826",
  null
  
)

export default component.exports